<template>
  <div class="coupon">
    <img
      class="back"
      @click="goHome"
      v-lazy="require('./../../../assets/img/back2.png')"
    />
    <van-tabs v-model="activeName" @click="getroadList">
      <van-tab :title="'未使用(' + couponListLen['unused'] + ')'" name="unused">
        <NoPic style="margin-top: 50%" v-if="!couponListLen['unused']"></NoPic>
        <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
          <van-list
            v-model="isUpLoading"
            :finished="upFinished"
            :immediate-check="false"
            :offset="10"
            finished-text="我是有底线的"
            @load="onLoadList"
          >
            <couponCard
              v-for="(item, index) in couponList.unused"
              :key="index"
              :item="item"
            ></couponCard>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab :title="'已使用(' + couponListLen['used'] + ')'" name="used">
        <NoPic style="margin-top: 50%" v-if="!couponListLen['used']"></NoPic>
        <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
          <van-list
            v-model="isUpLoading"
            :finished="upFinished"
            :immediate-check="false"
            :offset="10"
            finished-text="我是有底线的"
            @load="onLoadList"
          >
            <couponCard
              v-for="(item, index) in couponList.used"
              :key="index"
              :item="item"
            ></couponCard>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab
        :title="'已失效(' + couponListLen['invalid'] + ')'"
        name="invalid"
      >
        <NoPic style="margin-top: 50%" v-if="!couponListLen['invalid']"></NoPic>
        <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
          <van-list
            v-model="isUpLoading"
            :finished="upFinished"
            :immediate-check="false"
            :offset="10"
            finished-text="我是有底线的"
            @load="onLoadList"
          >
            <couponCard
              v-for="(item, index) in couponList.invalid"
              :key="index"
              :item="item"
            ></couponCard>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import couponCard from "@/components/couponCard";
import NoPic from "@/components/NoPic";
import { getMyCoupons } from "@/http/api";
export default {
  name: "coupon",
  data() {
    return {
      activeName: "unused",
      couponList: {
        unused: [],
        used: [],
        invalid: [],
      },
      couponListLen: {
        unused: 0,
        used: 0,
        invalid: 0,
      },
      // 分页
      total: 0,
      pageSize: 10, // 每页条数
      pageIndex: 1, // 页码
      isDownLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
    };
  },
  created() {
    // this.getroadList()
    let params = {
      page: this.pageIndex,
      page_size: this.pageSize,
    };
    getMyCoupons(params)
      .then((res) => {
        console.log("获取信息", res);
        // this.total = res.data.count;
        if (res.data.objects) {
          res.data.objects.forEach((element) => {
            this.couponList[element.status.key].push(element);
            this.couponListLen[element.status.key] =
              this.couponListLen[element.status.key] + 1;
          });
          console.log(this.couponList, this.couponListLen);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    goHome() {
      this.$router.push("/my/center");
    },
    getroadList() {
      this.couponList[this.activeName] = [];
      let params = {
        page: this.pageIndex,
        page_size: this.pageSize,
        status: this.activeName,
      };
      console.log(this.couponList[this.activeName].length);
      getMyCoupons(params)
        .then((res) => {
          console.log("获取信息", res);
          this.total = res.data.count;
          if (res.data.objects) {
            this.couponList[this.activeName] = this.couponList[
              this.activeName
            ].concat(res.data.objects);
            this.couponListLen[this.activeName] =
              this.couponList[this.activeName].length;
            console.log(
              this.couponList[this.activeName],
              this.couponListLen[this.activeName]
            );
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isDownLoading = false;
          this.isUpLoading = false;
        });
    },
    // 下拉刷新
    onDownRefresh() {
      this.couponList[this.activeName] = [];
      this.pageIndex = 1;
      this.upFinished = false; // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
      this.getroadList(); // 加载数据
    },
    // 上拉加载请求方法
    onLoadList() {
      if (this.total > this.pageIndex * this.pageSize) {
        this.pageIndex++;
        this.getroadList();
      } else {
        this.upFinished = true;
      }
    },
  },
  components: {
    couponCard,
    NoPic,
  },
};
</script>
<style lang="less">
.back {
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 5px;
  top: 5px;
  z-index: 100;
}
.coupon {
  .van-tab {
    background-color: #eceff5;
  }
  .van-tab--active {
    .van-tab__text {
      color: #42686e;
    }
  }
  .van-tabs__line {
    background-color: #42686e;
    // width: 100%;
  }
}
</style>